module.exports = __webpack_public_path__ + "static/assets/2ec3bc93354a0167b3ebb82df9c072d3.svg";